import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GAMES_CATEGORY_NAV } from "../../../routes/APP_ROUTES";
import GamesCategoryCard from "./GameCategoryCard";
import GameService from "../../../service/gameService";
import { CONFIG } from "../../../helpers/constants";
import GamesCategoryFilters from "./GamesCategoryFilters";
import { SORT_OPTIONS } from "./GAMES_FILTERS_DATA";
import { useTranslation } from "react-i18next";

const GamesCategoryPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const gameService = new GameService(CONFIG.BASE_URL);
  const [allProviders, setAllProviders] = useState([]);
  const [totalProviders, setTotalProviders] = useState(0);
  const [searchGames, setSearchGames] = useState("");
  const [sortBy, setSortBy] = useState(SORT_OPTIONS[1]);

  const [selectedProviderFilter, setSelectedProviderFilter] = useState("");
  const gamesCtaegoryNav = GAMES_CATEGORY_NAV();
  const currentCategory = gamesCtaegoryNav.find((item) => location.pathname.startsWith(item.path));

  const loadProviders = useCallback(async () => {
    try {
      const response = await gameService.fetchGamesProvider();

      setAllProviders(response.data);
      setTotalProviders(response.data?.length);
    } catch (error) {
      console.error("Failed to load providers:", error);
    } finally {
    }
  }, []);
  useEffect(() => {
    loadProviders();
  }, []);

  useEffect(() => {
    setSelectedProviderFilter(null);
  }, [location]);

  return (
    <div className="flex flex-col">
      <div className="mx-auto px-6 w-full">
        <GamesCategoryFilters
          setSelectedSortByFilter={setSortBy}
          selectedSortByFilter={sortBy}
          searchGames={searchGames}
          setSearchGames={setSearchGames}
          allProviders={allProviders}
          selectedProviderFilter={selectedProviderFilter}
          setSelectedProviderFilter={setSelectedProviderFilter}
        />
      </div>
      <section className="text-white overflow-hidden relative">
        <div className="max-w-[95rem] mx-auto md:p-0 px-6">
          {currentCategory ? (
            <GamesCategoryCard
              data={currentCategory}
              searchGames={searchGames}
              showAllCategories={false}
              allProviders={allProviders}
              selectedProviderFilter={selectedProviderFilter}
              setSelectedProviderFilter={setSelectedProviderFilter}
            />
          ) : (
            <p className="text-center text-gray-400">{t("Category not found.")}</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default GamesCategoryPage;
